"use strict";

// import '../lib/smooth-scroll/smooth-scroll.polyfills.min.js';
// import '../lib/jquery-3.4.1.mins.js';
// import $ from "jquery";
/*global  jQuery*/
jQuery(function ($) {
$(function () {
 //読み込みが完了
 $(window).on('load',function () { 
   console.log('jQuery Page Loaded.');  
 });
 
//  var state = false;
//  var scrollpos;

//  $('#menu-icon,#menu-background').on('click', function(){
//    if(state == false) {
//      scrollpos = $(window).scrollTop();
//      $('body').addClass('js-fixed').css({'top': -scrollpos});
//      state = true;
//    } else {
//      $('body').removeClass('js-fixed').css({'top': 0});
//      window.scrollTo( 0 , scrollpos );
//      state = false;
//    }
//  });

//任意のタブにURLからリンクするための設定
function GethashID (hashIDName){
	if(hashIDName){
		//タブ設定
		$('.bl_tab li').find('a').each(function() { //タブ内のaタグ全てを取得
			var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.bl_tab li').removeClass("is-active"); //タブ内のliについているactiveクラスを取り除き
				$(parentElm).addClass("is-active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".bl_tab_area").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
				$(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	
			}
		});
	}
}

//タブをクリックしたら
$('.bl_tab a').on('click', function() {
	var idName = $(this).attr('href'); //タブ内のリンク名を取得	
	GethashID (idName);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
    $('.bl_tab li:first-of-type').addClass("is-active"); //最初のliにactiveクラスを追加
    $('.bl_tab_area:first-of-type').addClass("is-active"); //最初の.areaにis-activeクラスを追加
	var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	GethashID (hashName);//設定したタブの読み込み
  requirementTab (hashName);
});

// 募集要項タブ切り替え
$('.bl_menuRequirement a').on('click',function(){
  var idName = $(this).attr('href');
  console.log('タブ切り替え：' + idName);
  requirementTab(idName);
  return false;  
});
function requirementTab(hashIDName) {
  if(hashIDName){
		//タブ設定
		$('.bl_menuRequirement li').find('a').each(function() { //タブ内のaタグ全てを取得
			var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				$('.bl_menuRequirement li a').removeClass("is-active"); //タブ内のliについているactiveクラスを取り除き
				$(this).addClass("is-active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".bl_contentsRequirement").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
				$(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	
			}
		});
	}
}



});
});

// jQuery(function ($) {
// $(function () {

//  $('js_toggle').on('click', function(){
//    $('js_inbox').slideToggle();
//  });

//  if ( $('.error')[0] ) {
//   $('.mw_wp_form').addClass('mw_wp_form_error');
//       var errorEl = $('.mw_wp_form').eq(0);
//       var position = errorEl.parent().offset().top + 0; //740の部分は上からなんpxの位置にスクロールしたいかを指定する。
//   $('body,html').delay(100).animate({scrollTop:position}, 200, 'swing');
// }

//  });
// });


// DOM読み込み完了
document.addEventListener('DOMContentLoaded', function(e) {
  console.log('DOM Content Loaded.');

  var menubtn = document.querySelectorAll('.btn-menu')[0];
  var menu = document.querySelectorAll('.site-menu .menu')[0];
  
  var menuParent = document.getElementsByClassName('menu-item-has-children');
  for( var i = 0; i < menuParent.length; i++ ) {
    menuParent[i].insertAdjacentHTML('afterbegin','<div class="toggle-submenu is-close"></div>');
  }

  var menuAncestor = document.querySelectorAll('.current-menu-ancestor > .toggle-submenu,.current-menu-item > .toggle-submenu');
  for( var i = 0; i < menuAncestor.length; i++ ) {
    menuAncestor[i].classList.toggle('is-close');
    menuAncestor[i].classList.toggle('is-open');
  }

  var btnToggle = document.getElementsByClassName('toggle-submenu');
  for (let i = 0; i < btnToggle.length; i++) {
    btnToggle[i].addEventListener('click', function() {
      btnToggle[i].classList.toggle('is-close');
      btnToggle[i].classList.toggle('is-open');
    }, false);
  }

  var scroll = new SmoothScroll('a[href*="#"]',{
    // Selectors
    ignore: '[data-scroll-ignore]', // Selector for links to ignore (must be a valid CSS selector)
    // header: '[data-scroll-header]', // Selector for fixed headers (must be a valid CSS selector)
    topOnEmptyHash: true, // Scroll to the top of the page for links with href="#"

    // Speed & Duration
    speed: 100, // Integer. Amount of time in milliseconds it should take to scroll 1000px
    // History
    updateURL: false, // Update the URL on scroll
    popstate: true, // Animate scrolling with the forward/backward browser buttons (requires updateURL to be true)
  });

  var state = false;
  var scrollpos;
  var drawerIcon = document.getElementById('drawer-icon');
  var drawerBackground = document.getElementById('drawer-background');
  var body = document.querySelectorAll('body')[0];

  function scrollStop() {
    if(state == false) {
      scrollpos = window.scrollY;
      body.classList.add('js-fixed');
      // body.style.top = -scrollpos + 'px';
      state = true;
    } else {
      body.classList.remove('js-fixed');
      // body.style.top = 0;
      // window.scrollTo( 0 , scrollpos );
      state = false;
    }
  }

  drawerIcon.addEventListener('click',scrollStop);
  drawerBackground.addEventListener('click',scrollStop);



}, false);

// スクロールイベント
window.addEventListener('scroll', () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if(window.pageYOffset > 150) {
    showHero();
  }else {
    hideHero();
  }
  // console.log('SCROLL-> ' + scrollTop + ':'+ mostBottom);
  if(scrollTop >= mostBottom) {
    upSideMenu();
  } else {
    downSideMenu();
  }
});


let allHeight = Math.max(
  document.body.scrollHeight, document.documentElement.scrollHeight,
  document.body.offsetHeight, document.documentElement.offsetHeight,
  document.body.clientHeight, document.documentElement.clientHeight
);
let mostBottom = allHeight - window.innerHeight - 220;

window.addEventListener('resize',function(){
  // console.log('RESIZE');
  allHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight
  );
  mostBottom = allHeight - window.innerHeight - 220;
});


function upSideMenu() {
  var target = document.getElementById('wrapper');
  target.classList.add('is-bottom');
  // console.log('bottome!!');
}
function downSideMenu() {
  var target = document.getElementById('wrapper');
  target.classList.remove('is-bottom');
}




function showHero() {
  var target = document.getElementsByClassName('ly_site')[0];
  target.classList.add('is-open');
}
function hideHero() {
  var target = document.getElementsByClassName('ly_site')[0];
  target.classList.remove('is-open');
}


// 完全に読み込み完了
window.addEventListener('load', function() {
  console.log('Page Loaded.');




// const heading = document.querySelector('#js-scroll-top-observer');
// const options = {
// //   // root: document.querySelector('.has-text-align-center'),
// //   // rootMargin: '-100px',
// threshold: 1
// }
// const observer = new IntersectionObserver(showHero, options);

// observer.observe(heading);

});

